import { ColorNordicGrey3 } from 'autogen/design-tokens/tokens';
import { css } from 'styled-components';
import defaultTheme from '../defaultTheme';

const borderTheme = {
    ...defaultTheme,
    ProductCard: css`
        border: 1px solid ${ColorNordicGrey3};
    `
};
export default borderTheme;
